import { render, staticRenderFns } from "./CompetitionList.vue?vue&type=template&id=d2566884&"
import script from "./CompetitionList.vue?vue&type=script&lang=js&"
export * from "./CompetitionList.vue?vue&type=script&lang=js&"
import style0 from "./CompetitionList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports